import { render, staticRenderFns } from "./apBreed.vue?vue&type=template&id=2e2a30d4&scoped=true&"
import script from "./apBreed.vue?vue&type=script&lang=js&"
export * from "./apBreed.vue?vue&type=script&lang=js&"
import style0 from "./apBreed.vue?vue&type=style&index=0&id=2e2a30d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a30d4",
  null
  
)

export default component.exports